import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarForwardLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.32227 8.00293C6.32227 7.65775 6.60208 7.37793 6.94727 7.37793H14.0273C14.3725 7.37793 14.6523 7.65775 14.6523 8.00293C14.6523 8.34808 14.3725 8.62791 14.0273 8.62791H6.94727C6.60208 8.62791 6.32227 8.34808 6.32227 8.00293Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.45361 1.875C7.79879 1.875 8.07861 2.15483 8.07861 2.5V4.64703C8.07861 4.99221 7.79879 5.27203 7.45361 5.27203C7.10843 5.27203 6.82861 4.99221 6.82861 4.64703V2.5C6.82861 2.15483 7.10843 1.875 7.45361 1.875Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5146 1.875C13.8598 1.875 14.1396 2.15483 14.1396 2.5V4.64703C14.1396 4.99221 13.8598 5.27203 13.5146 5.27203C13.1695 5.27203 12.8896 4.99221 12.8896 4.64703V2.5C12.8896 2.15483 13.1695 1.875 13.5146 1.875Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.12287 5.03273C4.65739 5.47636 4.35896 6.16637 4.36184 7.16489L4.36185 7.16669L4.36184 14.0116C4.36184 15.011 4.66174 15.7039 5.12891 16.1498C5.60051 16.6 6.32321 16.8755 7.31496 16.8755H13.6588C14.644 16.8755 15.3658 16.5965 15.8389 16.1378C16.3091 15.6822 16.6119 14.9737 16.6119 13.9548V7.16669C16.6119 6.16862 16.311 5.4778 15.8433 5.03329C15.3708 4.58418 14.6478 4.31006 13.6588 4.31006H7.30847C6.31575 4.31006 5.59323 4.58445 5.12287 5.03273ZM4.26048 4.12786C5.02519 3.39904 6.09174 3.06006 7.30847 3.06006H13.6588C14.8728 3.06006 15.9387 3.39931 16.7045 4.1273C17.4753 4.85988 17.8619 5.90988 17.8619 7.16669V13.9548C17.8619 15.2265 17.4772 16.2908 16.7089 17.0354C15.9438 17.777 14.8765 18.1255 13.6588 18.1255H7.31496C6.09726 18.1255 5.03089 17.7843 4.26579 17.054C3.49626 16.3194 3.11184 15.2678 3.11184 14.0116V7.16757C3.10841 5.91163 3.49107 4.86115 4.26048 4.12786Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.01562 12.7173C7.01562 12.3721 7.29544 12.0923 7.64062 12.0923H13.3066C13.6517 12.0923 13.9316 12.3721 13.9316 12.7173C13.9316 13.0625 13.6517 13.3423 13.3066 13.3423H7.64062C7.29544 13.3423 7.01562 13.0625 7.01562 12.7173Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.1566 10.6871C11.3919 10.4346 11.7874 10.4207 12.0399 10.6561L13.7605 12.2599C13.8873 12.3781 13.9593 12.5436 13.9593 12.7171C13.9593 12.8904 13.8873 13.056 13.7605 13.1742L12.0399 14.7781C11.7874 15.0134 11.3919 14.9995 11.1566 14.747C10.9213 14.4945 10.9351 14.099 11.1876 13.8636L12.4177 12.7171L11.1876 11.5705C10.9351 11.3351 10.9213 10.9396 11.1566 10.6871Z",
			fill: "currentColor"
		})
	]
});
export default SvgCalendarForwardLine;
